import { render, staticRenderFns } from "./admin-loan.vue?vue&type=template&id=21f9cd9c"
import script from "./admin-loan.vue?vue&type=script&lang=js"
export * from "./admin-loan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f9cd9c')) {
      api.createRecord('21f9cd9c', component.options)
    } else {
      api.reload('21f9cd9c', component.options)
    }
    module.hot.accept("./admin-loan.vue?vue&type=template&id=21f9cd9c", function () {
      api.rerender('21f9cd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/loan/admin-loan.vue"
export default component.exports